<form
    [formGroup]="form"
    *yssIsLoading="subFormIsLoading$ | async">
    <app-user-select-or-create
        [form]="form"
        [selectedUser]="action.customer"></app-user-select-or-create>
    <div class="row">
        <div class="col-6">
            <label class="padded-top-gray-label">Enter Query:</label>
            <ng-select
                formControlName="subtypeId"
                [clearable]="false"
                [searchable]="false"
                placeholder="Select Subject">
                <ng-option
                    *ngFor="let subtype of subtypes"
                    [value]="subtype.id">
                    {{ subtype.name }}
                </ng-option>
            </ng-select>
        </div>
        <div class="col-6 subject-select-holder">
            <label class="padded-top-gray-label">Subject for Account Query:</label>
            <input
                type="text"
                class="normal-text-input"
                placeholder="Enter second name"
                formControlName="subject"
                [ngClass]="{ 'normal-text-input--invalid': fieldIsValid('subject') }" />
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <input
                type="checkbox"
                class="form-check-input checkbox-dark-styled"
                formControlName="sendNotificationToCustomer" />
            <span class="sent-request-back-msg">
                Sent request back to the customer to appear on email and customer dashboard
            </span>
        </div>
    </div>
</form>
